import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

createListButtonStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: space-evenly;
                `,
                css`
                    justify-content: space-evenly;
                `,
                null,
                null,
                null,
            ])}
    `,
};
